import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-factory",
  "use": "icon-si-glyph-factory-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-factory\" id=\"icon-si-glyph-factory\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>Factory</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0.000000, 2.000000)\" fill=\"#434343\">\n            <g>\n                <path d=\"M13,0 L13,7 L9,4 L9,7 L5,4 L5,7 L0,4 L0,13 L15,13 L15,0 L13,0 L13,0 Z M3,10 L1,10 L1,8 L3,8 L3,10 L3,10 Z M7,10 L5,10 L5,8 L7,8 L7,10 L7,10 Z M11,10 L9,10 L9,8 L11,8 L11,10 L11,10 Z\" class=\"si-glyph-fill\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-factory.svg
// module id = yMm3
// module chunks = 62